<template>

  <div class="p-list-representation-record-modal-content w-100 row">
    <form id="signup-form" class="row w-100" v-on:submit.prevent="submit">

      <div class="row w-100">
            <div :class="{ 'p-list-representation-error': $v.formData.title.$error }"  class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
                <label  class="ml-4 p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
                  نام جام
                </label>
                <input v-model="formData.title" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>

            <div :class="{ 'p-list-representation-error': $v.formData.price.$error }" class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
                <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                  هزینه ورودی تیم
                </label>
                <input v-model="formData.price" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>

            <div :class="{ 'p-list-representation-error': $v.formData.using_type.$error }" class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                حوزه ورزشی
              </label>
              <input v-model="formData.using_type" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>

            <div class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                وضعیت
              </label>
              <multiselect
               v-model="valueStatus"
               :options="statusTableData"
               placeholder=''
               label="title"
               track-by="title"
               :show-labels="false"
               :allow-empty="false"
               :class="{ 'p-cup-error-multiselect ': $v.formData.status.$error }"
               class="col-lg-8"
               >
               </multiselect>
            </div>

            <div class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                جنسیت
              </label>
              <multiselect
               v-model="valueGender"
               :options="genderData"
               placeholder=''
               label="title"
               track-by="title"
               :show-labels="false"
               :allow-empty="false"
               class="col-lg-8"
               :class="{ 'p-cup-error-multiselect ': $v.formData.gender.$error }"
               >
               </multiselect>
            </div>

            <div :class="{ 'p-list-representation-error': $v.formData.age_group.$error }" class=" d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                گروه سنی
              </label>
              <input v-model="formData.age_group" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>


              <div  :class="{ 'p-list-representation-error': $v.formData.fixed_at.$error }"class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item p-cup-date-from" >
                <label  class=" p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
                  تاریخ بر گزاری از
                </label>
                <startEndSelectTime text-time="" :default-date="defaultValueDateHolding" check-start-end-time-status="start" @selectedDate="selectedDate"></startEndSelectTime>
              </div>

                <div :class="{ 'p-list-representation-error': $v.formData.content.$error }" class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
                    <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text ">
                      توضیحات
                    </label>
                    <textarea v-model="formData.content" class="form-control col-lg-8 pr-3 pl-3 pt-2 pb-2"  rows="4"></textarea>
                </div>

                <div :class="{ 'p-list-representation-error': $v.formData.rules.$error }" class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
                    <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text ">
                      قوانین مقررات
                    </label>
                    <textarea v-model="formData.rules" class="form-control col-lg-8 pr-3 pl-3 pt-2 pb-2"  rows="4"></textarea>
                </div>



            <div :class="{ 'p-list-representation-error': $v.formData.maximum_number_of_teams.$error }" class=" d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                ماکزیمم تعداد اعضا تیم
              </label>
              <input  v-model="formData.maximum_number_of_teams" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>



            <div :class="{ 'p-list-representation-error': $v.formData.minimum_number_of_players.$error }" class=" d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                مینیمم تعداد اعضای تیم
              </label>
              <input v-model="formData.minimum_number_of_players" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>


            <div :class="{ 'p-list-representation-error': $v.formData.maximum_number_of_players.$error }" class=" d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                ماکزیمم تعداد تیم در جام
              </label>
              <input v-model="formData.maximum_number_of_players"  type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>




      </div>


      <div class="flex-column justify-content-center w-100 p-list-salon-owner-export-btns d-flex flex-lg-row mb-5 mt-5">
          <button  type="submit" class="p-list-representation-btn btn btn-primary btn-sm  mr-0 mr-lg-4 btn-blue">
              ثبت/ویرایش
            </button>

            <button @click="editAndEntryMap" type="button" class="p-list-representation-btn btn btn-primary btn-sm  mr-0 mr-lg-4 btn-blue">
              ویرایش موقعیت مکانی
            </button>
      </div>


      <itemMap
       :value-title-location="valueTitleLocation"
       :location-data="formData"

       @titleLocation="titleLocation"
       @removeLocation="removeLocation"
      >
    </itemMap>

    <mapData
      :location-data="formData"
      @latLngCallBack="latLngCallBack"
      >
    </mapData>

    <button @click="submitLocation" type="button" class="mt-3 mb-3 btn btn-primary btn-sm  mr-0 mr-lg-4 btn-blue">
      ثبت/ویرایش
    </button>




    </form>

  </div>

</template>

<script>
import { required, minLength,between,numeric,maxLength } from 'vuelidate/lib/validators'
import isPhone from '../../plugins/checkPersianNumber.js';
import startEndSelectTime from './startEndSelectTime';
import itemMap from './itemMap';
import mapData from './mapData';



export default {
  name: 'formData',
  components: {
    startEndSelectTime,
    itemMap,
    mapData,
  },

  props: {
    statusTableData         : {type:[Array,Object],default:[]},
    formDataOriginal        : {type:[Array,Object],default:[]},
    genderData              : {type:[Array,Object],default:[]},
    valueTitleLocation      : {type:[String],default:''},
  },

  data() {
    return {
      formData : {

      },
      valueStatus             : '',
      valueGender             : '',
      defaultValueDateHolding : '',


    }
  },

  validations: {
    formData : {
        title: {
          required,
        },
        content: {
          required,
        },
        status: {
          required,
        },
        fixed_at: {
          required,
        },
        // image: {
        //   required,
        // },
        using_type: {
          required,
        },
        gender: {
          required,
        },
        price: {
          required,
        },
        age_group: {
          required,
        },
        maximum_number_of_teams: {
          required,
        },
        minimum_number_of_players: {
          required,
        },
        maximum_number_of_players: {
          required,
        },
        maximum_number_of_players: {
          required,
        },
        rules : {
          required,
        },




    },

  },

  computed: {

  },

  created() {
    this.formData = this.formDataOriginal;
  },

  mounted () {
    const getParams           = this.$route.params.id;

    if (typeof(getParams) != 'undefined') {
      this.setDefault();
    }

  },

  watch: {
    valueStatus(data){
      this.formData.status = data.id;
    },

    valueGender(data){
      this.formData.gender = data.id;
    }

  },

  methods: {
    editAndEntryMap() {
      this.$router.push({name:'mapLocation'})
    },

    submit() {
      this.$v.$touch()


      if (this.$v.$invalid) {
        window.scrollTo(0,0);
        this.$message.error('لطفا اطلاعات خود را بررسی کنید')
      }
      else {
        this.$emit('submitData',this.formData)
      }

    },

    updatePicCodeNational(blob){
      this.picCodeNationalPic = blob;
    },

    updatePicAgreement(blob){
      this.picAgreement = blob;
    },

    selectedDate(data){
      if (data.status == 'start') {
        this.formData.fixed_at  = data.date;

      }
      else {
        this.formData.to_date   = data.date;
      }

    },

    setDefault(){
      const findDefaultSelected = (data,defaultSelected) => {
        let findDefaultData = {};
        data.map((t)=>{
          if (t.id == defaultSelected) {
            findDefaultData = t;
          }
        })
        return findDefaultData;
      }


      const selectDefaultGender = () => {
         const getGender                    = this.formData.gender;
         const resultFindDefaultSelected    = findDefaultSelected(this.genderData,getGender);

         this.valueGender                   = resultFindDefaultSelected;
      }

      const selectDefaultStatus = () => {
        const getStatus                    = this.formData.status;
        const resultFindDefaultSelected    = findDefaultSelected(this.statusTableData,getStatus);

        this.valueStatus                   = resultFindDefaultSelected;
      }

      const getDefaultFromDateHolding = () => {
        const getDateHolding          = this.formData.fixedAtDateJlali;
        this.defaultValueDateHolding  = getDateHolding;
      }


      selectDefaultGender();
      selectDefaultStatus();
      getDefaultFromDateHolding();

    },

    titleLocation(data){
      this.$emit('titleLocation',data)
    },

    removeLocation(data){
      this.$emit('removeLocation',data)
    },

    latLngCallBack(data){
      this.$emit("latLngCallBack",data)
    },

    submitLocation(){
      this.$v.$touch()

      if (this.$v.$invalid) {
        window.scrollTo(0,0);
        this.$message.error('لطفا اطلاعات خود را بررسی کنید')
      }
      else {
        this.$emit("submitLocation",this.formData)
      }
    },

  },

}
</script>
